interface DownloadFilledProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

const DownloadFilled = ({ className = '', ...props }: DownloadFilledProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      {...props}
    >
      <path d="M5 20H19V18H5V20ZM19 9H15V3H9V9H5L12 16L19 9Z" fill="currentColor" />
    </svg>
  );
};

export default DownloadFilled;
